import { debounce } from 'lodash';
import { useEffect, useState } from 'react';

export const useDebounce = (value, duration = 200) => {
  const [internalValue, setInternalValue] = useState(value);

  const debouncedSet = debounce(() => {
    setInternalValue(value);
  }, duration);

  useEffect(() => {
    debouncedSet();
    return () => {
      debouncedSet.cancel();
    };
  }, [debouncedSet]);

  return internalValue;
};
